import React, { useEffect, useState } from "react";
import { Card, Pagination, Stack, Button, Paper } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Table from "examples/Tables/Table";
import TableData from "./data/tabledata";
import { baseURL } from "utils/api";
import Loading from "components/ApnaLoading";
import NotFound from "components/notFound";
import toast from "react-hot-toast";

import EditForm from "./editForm";
import { Download, TableChart, PictureAsPdf } from "@mui/icons-material";
import TermModal from "./termModal";
import SoftInput from "components/SoftInput";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom";
import CustomTable from '../../admin/components/atoms/Table'
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import ActionMenu from "admin/components/atoms/ActionButton";
import service from "../../admin/api/services";


function Index() {
  const [isApiLoading, setIsApiLoading] = React.useState(true)
  const userTheme = useSelector((state) => state.commonSlice.theme);
  const navigate = useNavigate();
  const matches = useMediaQuery("(max-width:600px)");
  const [data, setData] = useState(null);
  // const { columns, rows } = data;
  const id = localStorage.getItem("id");
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [search, setSearch] = React.useState('');
  const [isActive, setIsActive] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showTerm, setShowTerm] = useState(false);
  const [offerId, setOfferId] = useState("");
  const [searchData, setSearchData] = useState('');
  const [values, setValues] = useState({
    pin: '',
    estimatedSaving: '',
    locations: [],
  });
  const [mainType, setMainType] = useState('');
  const [refresh, setRefresh] = useState(0)
  const [allLocations, setAllLocations] = useState([]);
  const [sortValue, setSortValue] = React.useState({ sortKey: 'name', sortDirection: 'asc' });
  const columns = [
    {
      id: 'name',
      label: 'Name',
      orderBy: 'name',
      isSorting: true,
      sortDirection: 'asc',
      render: (row) => (
        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
          <SoftBox display="flex" flexDirection="column">
            <SoftTypography variant="button" fontWeight="medium">
              {row.name}
            </SoftTypography>
            <SoftTypography variant="caption" color="info">
              {row.org}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      ),
    },
    {
      id: 'type',
      label: 'Type',
      isSorting: true,
      sortDirection: 'asc',
      orderBy: 'type',
      render: (row) => (
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography variant="caption" fontWeight="bold" color="text">
            {row.type}
          </SoftTypography>
          <SoftTypography variant="caption" color="info">
            {row.org}
          </SoftTypography>
        </SoftBox>
      ),
    },
    {
      id: 'usageCount',
      label: 'Offer Count',
      isSorting: true,
      sortDirection: 'asc',
      orderBy: 'usageCount',
      render: (row) => (
        <SoftTypography variant="caption" fontWeight="medium">
          {row.usageCount}
        </SoftTypography>
      ),
    },
    {
      id: 'startDate',
      label: 'Start Date',
      isSorting: true,
      orderBy: 'startDate',
      render: (row) => (
        <SoftTypography variant="caption" fontWeight="medium">
          {new Date(row.startDate).toDateString()}
        </SoftTypography>
      ),
    },
    {
      id: 'endDate',
      label: 'End Date',
      isSorting: true,
      orderBy: 'endDate',
      sortDirection: 'asc',
      render: (row) => (
        <SoftTypography variant="caption" fontWeight="medium">
          {new Date(row.endDate).toDateString()}
        </SoftTypography>
      ),
    },
    {
      id: 'status',
      label: 'Status',
      sortDirection: 'asc',
      isSorting: false,
      render: (row) =>
        row?.status === 'EXPIRED' ? <SoftBadge color="error" badgeContent="EXPIRED" size="lg" /> : row?.isActive ? (
          <SoftBadge color="success" badgeContent="Active" size="lg" />
        ) : (
          <SoftButton
            onClick={() => {
              setIsActive(row.isActive);
              (row?.businessLocations?.length > 0 &&
                row.passcode !== "" &&
                row.savingPoints)
                ? ShowTerms(row._id)
                : handleEditOffer(row)
            }
            }
            variant="gradient"
            color="info"
            size="small"
          >
            {(row?.businessLocations?.length > 0 &&
              row.passcode !== "" &&
              row.savingPoints)
              ? 'Accept T&C'
              : 'Activate'}
          </SoftButton>
        ),
    },
    {
      id: 'action',
      label: 'Action',
      isSorting: false,
      render: (row) => (
        <ActionMenu
          items={[
            row?.status !== 'EXPIRED' && {
              label: 'Edit',
              onClick: () => {
                setIsActive(row?.isActive);
                handleEditOffer(row, row?.templateId ? 'edit' : 'create');
              },
            },
            {
              label: 'Detail',
              onClick: () => {
                if (row?._id) {
                  navigate(`/offerDetail/${row._id}`);
                } else {
                  console.error("Invalid row ID");
                }
              },
            },
          ].filter(Boolean)}
        />

      ),
    },
  ];

  const fetchData = async () => {
    try {
      setIsApiLoading(true)
      setLoading(true);
      setData(null)
      const response = await service.offer.merchantOfferDetail(id, { searchData: search, page, limit: rowsPerPage, sortKey: sortValue.sortKey, sortDirection: sortValue.sortDirection })
      setTotalPage(response?.data?.totalOffers || 0);
      setData(response?.data);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Something went wrong');
    }
    setIsApiLoading(false)
  };


  const handleEditOffer = (item, type) => {
    // First, clear previous values
    setValues({
      pin: '',
      estimatedSaving: '',
      locations: [],
    });

    // Use a short timeout to ensure clear happens before setting new values
    setTimeout(() => {
      if (item.templateId) {
        setValues({
          pin: item?.passcode || '',
          estimatedSaving: item?.savingPoints || '',
          locations: item?.businessLocations || [],
        });
      }

      setShow(true);
      setOfferId(item._id);
      setMainType(type);
    }, 0); // 0ms is usually enough to force next tick
  };

  const ShowTerms = (templateId) => {
    setShowTerm(true);
    setOfferId(templateId);
  };

  const handleActivateOffer = (templateId) => {
    fetch(`${baseURL}activate/offer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        businessUserId: id,
        offerId: templateId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setShowTerm(false);
          fetchData();
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        toast.error(err.message || 'Something went wrong');;
      });
  };




  const exportFile = (ev, searchData, main) => {
    setLoading(true);
    fetch(`${baseURL}export/offers/business/${id}?page=${ev}&searchData=${searchData}&export=${main}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          if (main === 'pdf') {
            // Convert base64 string back to binary
            const byteCharacters = atob(data.data); // base64 decode
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', 'file.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            const blob = new Blob([new Uint8Array(data?.data?.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', 'file.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        }
        setLoading(false);
      })
      .catch(err => {
        toast.error(err.message || 'Something went wrong');;
        setLoading(false);
      });
  };



  useEffect(() => {
    fetchData();
  }, [search, page, rowsPerPage, sortValue]);

  const getLocationData = async (value = '') => {
    try {
      let response = await service.offer.merchantOfferLocations(localStorage.getItem('id'), { searchData: value })
      if (response) {
        const locations = response?.data?.data;
        setAllLocations(
          locations?.length > 0
            ? locations.map((location, i) => ({
              _id: location?.locationId,
              name: location?.locationName || `location-${i}`,
              label: location?.locationName || `location-${i}`,
              value: location?._id,
              id: location?._id
            }))
            : []
        );
      }

    } catch (error) {

    }
  }
  useEffect(() => {
    getLocationData()
  }, [])

  const handelRefresh = () => {
    setRefresh(refresh + 1)
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <EditForm handelRefresh={handelRefresh} values={values} setValues={setValues} isActive={isActive}
        handleActivateOffer={ShowTerms} allLocations={allLocations} setShowTerm={setShowTerm} getLocationData={getLocationData}
        type={mainType} show={show} unShow={setShow} offerId={offerId} fetchData={fetchData} />
      <TermModal show={showTerm} unShow={setShowTerm} fetchData={fetchData} offerId={offerId} handleActivateOffer={handleActivateOffer} />

      <SoftBox display="flex" gap={2} alignItems='center' justifyContent='end' >
        <SoftButton
          variant="contained"
          style={{
            backgroundColor: userTheme === 'dark' ? '#1e1e1e' : '#e8f5e9',
            color: userTheme === 'dark' ? '#ffffff' : '#2e7d32',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          disabled={data?.data?.length === 0}
          onClick={() => exportFile(page, searchData, 'excel')}
        >
          <TableChart sx={{ fontSize: 30 }} />
          <SoftTypography variant="button" fontWeight="medium">
            Export Excel
          </SoftTypography>
        </SoftButton>
        <SoftButton
          variant="contained"
          style={{
            backgroundColor: userTheme === 'dark' ? '#1e1e1e' : '#fff3e0',
            color: userTheme === 'dark' ? '#ffffff' : '#e65100',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          disabled={data?.data?.length === 0}
          onClick={() => exportFile(page, searchData, 'pdf')}
        >
          <PictureAsPdf sx={{ fontSize: 30 }} />
          <SoftTypography variant="button" fontWeight="medium">
            Export PDF
          </SoftTypography>
        </SoftButton>
      </SoftBox>

      <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
        <SoftBox
          sx={{
            display: 'flex',
            flexDirection: matches ? 'column' : 'row',
            justifyContent: 'end',
            alignItems: 'center',

          }}
        >

        </SoftBox>
        <CustomTable
          title="Amenities List" columns={columns}
          rows={data?.data}
          isDone={true}
          search={search}
          setSearch={setSearch}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          totalPages={totalPage}
          isApiLoading={isApiLoading}
          onRequestSort={(id, direction) => {
            setSortValue({ sortKey: id, sortDirection: direction })

          }}
        />

      </Paper>


    </DashboardLayout>
  );
}

export default Index;
